"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.get = get;
exports.getMeta = getMeta;
exports.getBindings = getBindings;
exports.getCompanyId = getCompanyId;
exports.getContactId = getContactId;
exports.create = create;
exports.createViaSsoToken = createViaSsoToken;
exports.createWithJwt = createWithJwt;
exports.createWithLinkedAccountId = createWithLinkedAccountId;
exports.getUserJwtToken = getUserJwtToken;
exports.getJWTWithUDS = getJWTWithUDS;
exports.getWithUDS = getWithUDS;
exports.switchAccountWithLongToken = switchAccountWithLongToken;
exports.getLoginRedirectURL = getLoginRedirectURL;
exports.viewPortal = viewPortal;
exports.exitViewPortal = exitViewPortal;
exports.deleteSession = deleteSession;
exports.getIACsWithFallback = getIACsWithFallback;

_Object$defineProperty(exports, "store", {
  enumerable: true,
  get: function get() {
    return _store.store;
  }
});

exports.sso = exports.interceptor = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/ends-with"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _access = require("../access");

var _environment = require("../environment");

var _constants = require("../environment/constants");

var _utils = require("../utils");

var _internals = require("../utils/internals");

var _constants2 = require("./constants");

var _store = require("./store");

var _interceptor = _interopRequireWildcard(require("./interceptor"));

var _sso = _interopRequireWildcard(require("./sso"));

var interceptor = _interceptor;
exports.interceptor = interceptor;
var sso = _sso;
exports.sso = sso;

function filterGrants(obj, prop) {
  return obj[prop] === 'Granted';
}

function getSessionAndBindings(_x) {
  return _getSessionAndBindings.apply(this, arguments);
}

function _getSessionAndBindings() {
  _getSessionAndBindings = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(auth) {
    var avoidInterceptor,
        _args4 = arguments;
    return _regenerator.default.wrap(function _callee4$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            avoidInterceptor = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
            return _context7.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              var _context;

              return (0, _concat.default)(_context = "".concat(base, "/v1/session-and-bindings")).call(_context, avoidInterceptor ? "?".concat(_interceptor.preventOnUnauthorizedHeader) : '');
            }).then( /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
                return _regenerator.default.wrap(function _callee$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", fetch(url, {
                          cache: 'force-cache',
                          headers: (0, _utils.jsonHeaders)(auth ? {
                            Authorization: auth
                          } : {})
                        }));

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x18) {
                return _ref5.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(response) {
                return _regenerator.default.wrap(function _callee2$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(response.status > 400)) {
                          _context3.next = 2;
                          break;
                        }

                        return _context3.abrupt("return", _promise.default.reject(new Error(response.statusText)));

                      case 2:
                        return _context3.abrupt("return", _promise.default.resolve(response));

                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x19) {
                return _ref6.apply(this, arguments);
              };
            }()).then( /*#__PURE__*/function () {
              var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(response) {
                return _regenerator.default.wrap(function _callee3$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        return _context4.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x20) {
                return _ref7.apply(this, arguments);
              };
            }()).then(function (data) {
              var _context5;

              var UdsSession = data.UdsSession,
                  UdsSessionBindings = data.UdsSessionBindings;
              var frpMap = UdsSessionBindings.FeatureResourcePermissions.FeatureResourcePermissionsMap;
              UdsSessionBindings.Grants = (0, _map.default)(_context5 = (0, _utils.flattenKeys)(frpMap, filterGrants)).call(_context5, function (key) {
                return _constants2.grantsMap[key];
              });

              if (_access.is.client(UdsSessionBindings.Grants) || _access.is.staff(UdsSessionBindings.Grants)) {}

              if (UdsSession.FirstName) {
                var _context6;

                UdsSession.FullName = (0, _concat.default)(_context6 = "".concat(UdsSession.FirstName, " ")).call(_context6, UdsSession.LastName);
                UdsSession.Initials = UdsSession.FirstName.charAt(0) + UdsSession.LastName.charAt(0);
              } else {
                UdsSession.FullName = UdsSession.LastName;
                UdsSession.Initials = UdsSession.LastName.charAt(0);
              }

              return {
                meta: UdsSession,
                bindings: UdsSessionBindings
              };
            }));

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee4);
  }));
  return _getSessionAndBindings.apply(this, arguments);
}

var metaSessionAndBindingsPromise;

function get() {
  return _get.apply(this, arguments);
}

function _get() {
  _get = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
    var opts,
        force,
        avoidInterceptor,
        auth,
        _args6 = arguments;
    return _regenerator.default.wrap(function _callee6$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            opts = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
            force = opts.force === undefined ? false : opts.force;
            avoidInterceptor = opts.avoidInterceptor === undefined ? false : opts.avoidInterceptor;
            auth = opts.auth;

            if (!auth) {
              _context9.next = 6;
              break;
            }

            return _context9.abrupt("return", getSessionAndBindings(auth));

          case 6:
            if (force) {
              metaSessionAndBindingsPromise = null;
            }

            if (!metaSessionAndBindingsPromise) {
              metaSessionAndBindingsPromise = getSessionAndBindings(undefined, avoidInterceptor).catch( /*#__PURE__*/function () {
                var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(error) {
                  return _regenerator.default.wrap(function _callee5$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          metaSessionAndBindingsPromise = null;
                          return _context8.abrupt("return", _promise.default.reject(error));

                        case 2:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee5);
                }));

                return function (_x21) {
                  return _ref8.apply(this, arguments);
                };
              }());
            }

            return _context9.abrupt("return", metaSessionAndBindingsPromise);

          case 9:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee6);
  }));
  return _get.apply(this, arguments);
}

function getMeta() {
  return _getMeta.apply(this, arguments);
}

function _getMeta() {
  _getMeta = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
    var _ref,
        force,
        auth,
        _args7 = arguments;

    return _regenerator.default.wrap(function _callee7$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _ref = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {}, force = _ref.force, auth = _ref.auth;
            return _context10.abrupt("return", get({
              force: force,
              auth: auth
            }).then(function (data) {
              return data.meta;
            }));

          case 2:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee7);
  }));
  return _getMeta.apply(this, arguments);
}

function getBindings() {
  return _getBindings.apply(this, arguments);
}

function _getBindings() {
  _getBindings = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
    var _ref2,
        force,
        auth,
        _args8 = arguments;

    return _regenerator.default.wrap(function _callee8$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _ref2 = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {}, force = _ref2.force, auth = _ref2.auth;
            return _context11.abrupt("return", get({
              force: force,
              auth: auth
            }).then(function (data) {
              return data.bindings;
            }));

          case 2:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee8);
  }));
  return _getBindings.apply(this, arguments);
}

function getCompanyId() {
  return _getCompanyId.apply(this, arguments);
}

function _getCompanyId() {
  _getCompanyId = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
    var _ref3,
        force,
        auth,
        _args9 = arguments;

    return _regenerator.default.wrap(function _callee9$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _ref3 = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {}, force = _ref3.force, auth = _ref3.auth;
            return _context12.abrupt("return", get({
              force: force,
              auth: auth
            }).then(function (data) {
              return data.bindings.ApplicationConfiguration.CompanyId;
            }));

          case 2:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee9);
  }));
  return _getCompanyId.apply(this, arguments);
}

function getContactId() {
  return _getContactId.apply(this, arguments);
}

function _getContactId() {
  _getContactId = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
    var _ref4,
        force,
        auth,
        _args10 = arguments;

    return _regenerator.default.wrap(function _callee10$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _ref4 = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {}, force = _ref4.force, auth = _ref4.auth;
            return _context13.abrupt("return", get({
              force: force,
              auth: auth
            }).then(function (data) {
              return data.bindings.ApplicationConfiguration.ContactId;
            }));

          case 2:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee10);
  }));
  return _getContactId.apply(this, arguments);
}

function create(_x2, _x3) {
  return _create.apply(this, arguments);
}

function _create() {
  _create = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(username, password) {
    return _regenerator.default.wrap(function _callee13$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              return "".concat(base, "/v2/sessions/jwt");
            }).then( /*#__PURE__*/function () {
              var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(url) {
                return _regenerator.default.wrap(function _callee11$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        return _context14.abrupt("return", fetch(url, {
                          body: (0, _stringify.default)({
                            username: username,
                            password: password
                          }),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee11);
              }));

              return function (_x22) {
                return _ref9.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(response) {
                return _regenerator.default.wrap(function _callee12$(_context15) {
                  while (1) {
                    switch (_context15.prev = _context15.next) {
                      case 0:
                        return _context15.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context15.stop();
                    }
                  }
                }, _callee12);
              }));

              return function (_x23) {
                return _ref10.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee13);
  }));
  return _create.apply(this, arguments);
}

function createViaSsoToken(_x4) {
  return _createViaSsoToken.apply(this, arguments);
}

function _createViaSsoToken() {
  _createViaSsoToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(token) {
    return _regenerator.default.wrap(function _callee16$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            return _context21.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              var _context17, _context18;

              return (0, _concat.default)(_context17 = (0, _concat.default)(_context18 = "".concat(base, "/v1/sso?")).call(_context18, _constants2.ssoTokenKey, "=")).call(_context17, token);
            }).then( /*#__PURE__*/function () {
              var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(url) {
                return _regenerator.default.wrap(function _callee14$(_context19) {
                  while (1) {
                    switch (_context19.prev = _context19.next) {
                      case 0:
                        return _context19.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context19.stop();
                    }
                  }
                }, _callee14);
              }));

              return function (_x24) {
                return _ref11.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(response) {
                return _regenerator.default.wrap(function _callee15$(_context20) {
                  while (1) {
                    switch (_context20.prev = _context20.next) {
                      case 0:
                        return _context20.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context20.stop();
                    }
                  }
                }, _callee15);
              }));

              return function (_x25) {
                return _ref12.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee16);
  }));
  return _createViaSsoToken.apply(this, arguments);
}

function createWithJwt(_x5) {
  return _createWithJwt.apply(this, arguments);
}

function _createWithJwt() {
  _createWithJwt = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(jwt) {
    return _regenerator.default.wrap(function _callee19$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            return _context24.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              return "".concat(base, "/v3/sessions/jwt");
            }).then( /*#__PURE__*/function () {
              var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(url) {
                return _regenerator.default.wrap(function _callee17$(_context22) {
                  while (1) {
                    switch (_context22.prev = _context22.next) {
                      case 0:
                        return _context22.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)({
                            Authorization: "Bearer ".concat(jwt)
                          }),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context22.stop();
                    }
                  }
                }, _callee17);
              }));

              return function (_x26) {
                return _ref13.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(response) {
                return _regenerator.default.wrap(function _callee18$(_context23) {
                  while (1) {
                    switch (_context23.prev = _context23.next) {
                      case 0:
                        return _context23.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context23.stop();
                    }
                  }
                }, _callee18);
              }));

              return function (_x27) {
                return _ref14.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee19);
  }));
  return _createWithJwt.apply(this, arguments);
}

function createWithLinkedAccountId(_x6) {
  return _createWithLinkedAccountId.apply(this, arguments);
}

function _createWithLinkedAccountId() {
  _createWithLinkedAccountId = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(linkedAccountId) {
    return _regenerator.default.wrap(function _callee22$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            return _context29.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              var _context25;

              return (0, _concat.default)(_context25 = "".concat(base, "/v2/sessions/accounts/")).call(_context25, linkedAccountId);
            }).then( /*#__PURE__*/function () {
              var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(url) {
                return _regenerator.default.wrap(function _callee20$(_context26) {
                  while (1) {
                    switch (_context26.prev = _context26.next) {
                      case 0:
                        return _context26.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context26.stop();
                    }
                  }
                }, _callee20);
              }));

              return function (_x28) {
                return _ref15.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21(response) {
                return _regenerator.default.wrap(function _callee21$(_context27) {
                  while (1) {
                    switch (_context27.prev = _context27.next) {
                      case 0:
                        return _context27.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context27.stop();
                    }
                  }
                }, _callee21);
              }));

              return function (_x29) {
                return _ref16.apply(this, arguments);
              };
            }()).then(function (response) {
              if (response.RedirectingDomain) {
                var _context28;

                var ssoUrl = response.RedirectingDomain;
                var routingPath = response.RoutingPath;

                if (routingPath) {
                  var subPath = (0, _startsWith.default)(routingPath).call(routingPath, '/') && (0, _endsWith.default)(ssoUrl).call(ssoUrl, '/') ? routingPath.substring(1) : routingPath;
                  ssoUrl += subPath;
                }

                if (!(0, _includes.default)(ssoUrl).call(ssoUrl, '#')) {
                  ssoUrl = "".concat(ssoUrl, "#/");
                }

                ssoUrl = (0, _concat.default)(_context28 = "".concat(ssoUrl, "?token=")).call(_context28, response.SsoTokenId);
                response.SSOURL = ssoUrl;
              }

              return response;
            }));

          case 1:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee22);
  }));
  return _createWithLinkedAccountId.apply(this, arguments);
}

function getUserJwtToken(_x7) {
  return _getUserJwtToken.apply(this, arguments);
}

function _getUserJwtToken() {
  _getUserJwtToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee25(contactId) {
    return _regenerator.default.wrap(function _callee25$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            if (!(typeof contactId === 'undefined')) {
              _context33.next = 2;
              break;
            }

            return _context33.abrupt("return", _promise.default.reject(new Error('Invalid contact - unable to get jwt token')));

          case 2:
            return _context33.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              var _context30;

              return (0, _concat.default)(_context30 = "".concat(base, "/v1/jwt/contacts/")).call(_context30, contactId);
            }).then( /*#__PURE__*/function () {
              var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(url) {
                return _regenerator.default.wrap(function _callee23$(_context31) {
                  while (1) {
                    switch (_context31.prev = _context31.next) {
                      case 0:
                        return _context31.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context31.stop();
                    }
                  }
                }, _callee23);
              }));

              return function (_x30) {
                return _ref17.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee24(response) {
                return _regenerator.default.wrap(function _callee24$(_context32) {
                  while (1) {
                    switch (_context32.prev = _context32.next) {
                      case 0:
                        return _context32.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context32.stop();
                    }
                  }
                }, _callee24);
              }));

              return function (_x31) {
                return _ref18.apply(this, arguments);
              };
            }()));

          case 3:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee25);
  }));
  return _getUserJwtToken.apply(this, arguments);
}

function getJWTWithUDS(_x8) {
  return _getJWTWithUDS.apply(this, arguments);
}

function _getJWTWithUDS() {
  _getJWTWithUDS = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee28(uds) {
    return _regenerator.default.wrap(function _callee28$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            return _context36.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              return "".concat(base, "/v1/jwt/sessions");
            }).then( /*#__PURE__*/function () {
              var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee26(url) {
                return _regenerator.default.wrap(function _callee26$(_context34) {
                  while (1) {
                    switch (_context34.prev = _context34.next) {
                      case 0:
                        return _context34.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)({
                            Authorization: "UDSLongToken ".concat(uds)
                          }),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context34.stop();
                    }
                  }
                }, _callee26);
              }));

              return function (_x32) {
                return _ref19.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref20 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee27(response) {
                return _regenerator.default.wrap(function _callee27$(_context35) {
                  while (1) {
                    switch (_context35.prev = _context35.next) {
                      case 0:
                        return _context35.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context35.stop();
                    }
                  }
                }, _callee27);
              }));

              return function (_x33) {
                return _ref20.apply(this, arguments);
              };
            }()).then(function (response) {
              return response.token;
            }));

          case 1:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee28);
  }));
  return _getJWTWithUDS.apply(this, arguments);
}

function getWithUDS(_x9) {
  return _getWithUDS.apply(this, arguments);
}

function _getWithUDS() {
  _getWithUDS = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee31(uds) {
    return _regenerator.default.wrap(function _callee31$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            return _context39.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              return "".concat(base, "/v1/sessions");
            }).then( /*#__PURE__*/function () {
              var _ref21 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee29(url) {
                return _regenerator.default.wrap(function _callee29$(_context37) {
                  while (1) {
                    switch (_context37.prev = _context37.next) {
                      case 0:
                        return _context37.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)({
                            Authorization: "UDSLongToken ".concat(uds)
                          }),
                          method: 'GET'
                        }));

                      case 1:
                      case "end":
                        return _context37.stop();
                    }
                  }
                }, _callee29);
              }));

              return function (_x34) {
                return _ref21.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref22 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee30(response) {
                return _regenerator.default.wrap(function _callee30$(_context38) {
                  while (1) {
                    switch (_context38.prev = _context38.next) {
                      case 0:
                        return _context38.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context38.stop();
                    }
                  }
                }, _callee30);
              }));

              return function (_x35) {
                return _ref22.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee31);
  }));
  return _getWithUDS.apply(this, arguments);
}

function switchAccountWithLongToken(_x10) {
  return _switchAccountWithLongToken.apply(this, arguments);
}

function _switchAccountWithLongToken() {
  _switchAccountWithLongToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee32(longToken) {
    return _regenerator.default.wrap(function _callee32$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            _store.store.uds(undefined, true);

            _store.store.uds(longToken);

            return _context40.abrupt("return", getLoginRedirectURL("UDSLongToken ".concat(longToken)));

          case 3:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee32);
  }));
  return _switchAccountWithLongToken.apply(this, arguments);
}

function getLoginRedirectURL(_x11, _x12) {
  return _getLoginRedirectURL.apply(this, arguments);
}

function _getLoginRedirectURL() {
  _getLoginRedirectURL = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee33(auth, overwriteUrl) {
    return _regenerator.default.wrap(function _callee33$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            return _context41.abrupt("return", _promise.default.all([(0, _environment.getEnvironmentAsync)(), get({
              auth: auth
            })]).then(function (_ref23) {
              var _ref24 = (0, _slicedToArray2.default)(_ref23, 2),
                  environment = _ref24[0],
                  session = _ref24[1];

              if (overwriteUrl) {
                return overwriteUrl(session, auth);
              }

              var grants = session.bindings.Grants;
              var destUrl = '';

              if (_access.is.samba(grants)) {
                destUrl = _constants2.sambaDestUrl;
              } else if (_access.is.emergingAccounts(grants)) {
                destUrl = _constants2.emergingAccountsUrl;
              } else if (_access.is.staff(grants)) {
                destUrl = _constants2.staffDestUrl;
              } else if (_access.is.myPayOnboardingClient(grants)) {
                destUrl = _constants2.clientMyPayOnboardingUrl;
              } else if (_access.is.clientBeta(grants, session.bindings.InfrastructureAccessControls)) {
                destUrl = _constants2.clientBetaDestUrl;
              } else if (_access.is.atendimentoClient(grants, environment)) {
                destUrl = _constants2.atendimentoClientDestUrl;
              } else if (_access.is.client(grants)) {
                destUrl = _constants2.clientDestUrl;
              } else if (_access.is.myPayOnboardingRefAccountant(grants)) {
                destUrl = _constants2.refAccountantMyPayOnboardingUrl;
              } else if (_access.is.employee(grants)) {
                destUrl = _constants2.employeeDestUrl;
              } else if (_access.is.employer(grants)) {
                destUrl = _constants2.employerDestUrl;
              } else if (_access.is.esalesCustomerCenter(grants)) {
                destUrl = _constants2.esalesCustomerDestUrl;
              } else if (_access.is.staffDocumentsBasic(grants)) {
                destUrl = _constants2.staffDestUrl;
              } else if (_access.is.csAdmin(grants)) {
                destUrl = _constants2.csWebLoginUriMap[_constants.type];
              }

              return destUrl;
            }));

          case 1:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee33);
  }));
  return _getLoginRedirectURL.apply(this, arguments);
}

function viewPortal(_x13, _x14, _x15, _x16) {
  return _viewPortal.apply(this, arguments);
}

function _viewPortal() {
  _viewPortal = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee36(contactId, companyId, userId, params) {
    return _regenerator.default.wrap(function _callee36$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            return _context44.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              return "".concat(base, "/v2/sessions/view-portal");
            }).then( /*#__PURE__*/function () {
              var _ref25 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee34(url) {
                return _regenerator.default.wrap(function _callee34$(_context42) {
                  while (1) {
                    switch (_context42.prev = _context42.next) {
                      case 0:
                        return _context42.abrupt("return", fetch(url, {
                          body: (0, _stringify.default)({
                            id: contactId,
                            companyId: companyId,
                            userId: userId
                          }),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context42.stop();
                    }
                  }
                }, _callee34);
              }));

              return function (_x36) {
                return _ref25.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref26 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee35(response) {
                return _regenerator.default.wrap(function _callee35$(_context43) {
                  while (1) {
                    switch (_context43.prev = _context43.next) {
                      case 0:
                        return _context43.abrupt("return", _promise.default.all([response, response.json()]));

                      case 1:
                      case "end":
                        return _context43.stop();
                    }
                  }
                }, _callee35);
              }));

              return function (_x37) {
                return _ref26.apply(this, arguments);
              };
            }()).then(function (_ref27) {
              var _ref28 = (0, _slicedToArray2.default)(_ref27, 2),
                  response = _ref28[0],
                  body = _ref28[1];

              if (response.status === 403 && Boolean(body) && Boolean(body.data.message) && body.data.message === 'CC_USER_HAS_BETA') {
                window.location.href = _constants2.clientBetaDestUrl;
                return;
              }

              _store.store.uds(body.LongToken);

              if (typeof window !== 'undefined') {
                window.sessionStorage.setItem(_constants2.destinationStorageKey, window.location.href);
                (0, _access.has)('ClientCenterVnext').then(function (isCCVNext) {
                  if (isCCVNext) {
                    if (params === null || params === void 0 ? void 0 : params.taskId) {
                      window.location.href = _constants2.clientBetaDestUrl + "tasks/".concat(params.taskId);
                    } else {
                      window.location.href = _constants2.clientBetaDestUrl;
                    }
                  } else {
                    (0, _environment.getEnvironmentAsync)().then(function (env) {
                      if (env.countryCode === 'BR') {
                        window.location.href = _constants2.atendimentoClientDestUrl;
                      } else {
                        window.location.href = _constants2.clientDestUrl;
                      }
                    }).catch(console.error);
                  }
                }).catch(console.error);
              }
            }));

          case 1:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee36);
  }));
  return _viewPortal.apply(this, arguments);
}

function exitViewPortal() {
  return _exitViewPortal.apply(this, arguments);
}

function _exitViewPortal() {
  _exitViewPortal = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee39() {
    return _regenerator.default.wrap(function _callee39$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            return _context47.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              return "".concat(base, "/v1/sessions/view-portal/exit");
            }).then( /*#__PURE__*/function () {
              var _ref29 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee37(url) {
                return _regenerator.default.wrap(function _callee37$(_context45) {
                  while (1) {
                    switch (_context45.prev = _context45.next) {
                      case 0:
                        return _context45.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context45.stop();
                    }
                  }
                }, _callee37);
              }));

              return function (_x38) {
                return _ref29.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref30 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee38(response) {
                return _regenerator.default.wrap(function _callee38$(_context46) {
                  while (1) {
                    switch (_context46.prev = _context46.next) {
                      case 0:
                        return _context46.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context46.stop();
                    }
                  }
                }, _callee38);
              }));

              return function (_x39) {
                return _ref30.apply(this, arguments);
              };
            }()).then(function (body) {
              _store.store.uds(body.LongToken);

              if (typeof window !== 'undefined') {
                var _window$sessionStorag;

                var returnUrl = (_window$sessionStorag = window.sessionStorage.getItem(_constants2.destinationStorageKey)) !== null && _window$sessionStorag !== void 0 ? _window$sessionStorag : _constants2.staffDestUrl;
                window.sessionStorage.removeItem(_constants2.destinationStorageKey);
                window.location.href = returnUrl;
              }
            }));

          case 1:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee39);
  }));
  return _exitViewPortal.apply(this, arguments);
}

function deleteSession(_x17) {
  return _deleteSession.apply(this, arguments);
}

function _deleteSession() {
  _deleteSession = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee41(token) {
    var keepalive,
        _args41 = arguments;
    return _regenerator.default.wrap(function _callee41$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            keepalive = _args41.length > 1 && _args41[1] !== undefined ? _args41[1] : false;
            return _context49.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              return "".concat(base, "/v1/sessions");
            }).then( /*#__PURE__*/function () {
              var _ref31 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee40(url) {
                return _regenerator.default.wrap(function _callee40$(_context48) {
                  while (1) {
                    switch (_context48.prev = _context48.next) {
                      case 0:
                        return _context48.abrupt("return", fetch(url, {
                          keepalive: keepalive,
                          headers: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _utils.jsonHeaders)()), {}, {
                            authorization: "UDSLongToken ".concat(token)
                          }),
                          method: 'DELETE'
                        }));

                      case 1:
                      case "end":
                        return _context48.stop();
                    }
                  }
                }, _callee40);
              }));

              return function (_x40) {
                return _ref31.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 2:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee41);
  }));
  return _deleteSession.apply(this, arguments);
}

function getIACsWithFallback() {
  return _getIACsWithFallback.apply(this, arguments);
}

function _getIACsWithFallback() {
  _getIACsWithFallback = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee42() {
    var response, _response;

    return _regenerator.default.wrap(function _callee42$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            _context50.prev = 0;
            _context50.next = 3;
            return get({
              avoidInterceptor: true
            });

          case 3:
            response = _context50.sent;
            return _context50.abrupt("return", response.bindings.InfrastructureAccessControls);

          case 7:
            _context50.prev = 7;
            _context50.t0 = _context50["catch"](0);
            _context50.next = 11;
            return (0, _environment.getEnvironmentAsync)();

          case 11:
            _response = _context50.sent;
            return _context50.abrupt("return", _response.InfrastructureAccessControls);

          case 13:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee42, null, [[0, 7]]);
  }));
  return _getIACsWithFallback.apply(this, arguments);
}
